import * as Types from '../../doorhub-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UseLainaamoCodeMutationVariables = Types.Exact<{
  code: Types.Scalars['String'];
}>;


export type UseLainaamoCodeMutation = { __typename?: 'Mutation', useLainaamoCode: { __typename?: 'UseLainaamoCodeResponse', success: boolean } };


export const UseLainaamoCodeDocument = gql`
    mutation useLainaamoCode($code: String!) {
  useLainaamoCode(code: $code) {
    success
  }
}
    `;
export type UseLainaamoCodeMutationFn = Apollo.MutationFunction<UseLainaamoCodeMutation, UseLainaamoCodeMutationVariables>;

/**
 * __useUseLainaamoCodeMutation__
 *
 * To run a mutation, you first call `useUseLainaamoCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseLainaamoCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useLainaamoCodeMutation, { data, loading, error }] = useUseLainaamoCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useUseLainaamoCodeMutation(baseOptions?: Apollo.MutationHookOptions<UseLainaamoCodeMutation, UseLainaamoCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseLainaamoCodeMutation, UseLainaamoCodeMutationVariables>(UseLainaamoCodeDocument, options);
      }
export type UseLainaamoCodeMutationHookResult = ReturnType<typeof useUseLainaamoCodeMutation>;
export type UseLainaamoCodeMutationResult = Apollo.MutationResult<UseLainaamoCodeMutation>;
export type UseLainaamoCodeMutationOptions = Apollo.BaseMutationOptions<UseLainaamoCodeMutation, UseLainaamoCodeMutationVariables>;